export default __webpack_public_path__ + "static/media/logo.3ff70f8e.svg";